// test2276
(2276 && 0);
